module.exports = __webpack_public_path__ + "static/truckslider-01-min-6647850d35cd7f8316e1d085ef4fe531.jpg";